document.addEventListener('DOMContentLoaded', function () {    
    var swiper = new Swiper(".article_review-slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {    
        767: {
          slidesPerView: 2,
        },    
        1200: {
          slidesPerView: 2,
        },
      },
    });

    var postslider = new Swiper(".swiper-posts-slider", {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {    
        767: {
          slidesPerView: 2,
        },    
        1200: {
          slidesPerView: 3,
        },
      },
    });
  });